import { render, staticRenderFns } from "./TripContactDetails.vue?vue&type=template&id=34751d6a&"
import script from "./TripContactDetails.vue?vue&type=script&lang=js&"
export * from "./TripContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34751d6a')) {
      api.createRecord('34751d6a', component.options)
    } else {
      api.reload('34751d6a', component.options)
    }
    module.hot.accept("./TripContactDetails.vue?vue&type=template&id=34751d6a&", function () {
      api.rerender('34751d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/TripContactDetails.vue"
export default component.exports